import { useCollection } from "api/hooks/useCollection";
import { Collections, Season } from "api/model";
import { useMemo } from "react";

export const useCurrentSeason = () => {
    const seasons = useCollection<Season[]>(
        {
            collection: Collections.SEASONS,
            where: ["current", "==", true],
            orderBy: ["endAt", "desc"],
            limit: 1,
            storeAs: "currentSeason",
        },
        true
    );
    return useMemo(() => seasons[0], [seasons]);
};
